module.exports = __webpack_public_path__ + "static/media/task_asign_three.63f69b7d.png";